// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.w-md-editor {
  color: #24292e;
  text-align: left;
  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.1), 0 0 0 rgba(16, 22, 26, 0), 0 1px 1px rgba(16, 22, 26, 0.2);
  border-radius: 3px;
  position: relative;
  background-color: #fff;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
}
.w-md-editor-content {
  position: relative;
  border-radius: 0 0 3px 0;
  height: calc(100% - 39.1px);
}
.w-md-editor-input {
  width: 50%;
  height: 100%;
}
.w-md-editor-preview {
  width: 50%;
  box-sizing: border-box;
  box-shadow: inset 1px 0 0 0 #dfdfe0;
  position: absolute;
  padding: 10px 20px;
  overflow: auto;
  top: 0;
  right: 0;
  bottom: 0;
}
.w-md-editor-show-preview .w-md-editor-input {
  width: 0%;
  overflow: hidden;
  background-color: #fdfdfd;
}
.w-md-editor-show-preview .w-md-editor-preview {
  width: 100%;
  box-shadow: inset 0 0 0 0;
}
.w-md-editor-show-edit .w-md-editor-input {
  width: 100%;
}
.w-md-editor-show-edit .w-md-editor-preview {
  width: 0%;
  padding: 0;
}
.w-md-editor-fullscreen {
  overflow: hidden;
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.w-md-editor-fullscreen .w-md-editor-content {
  height: 100%;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@uiw/react-md-editor/lib/esm/index.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gBAAgB;EAChB,uGAAuG;EACvG,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,2DAA2D;AAC7D;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,2BAA2B;AAC7B;AACA;EACE,UAAU;EACV,YAAY;AACd;AACA;EACE,UAAU;EACV,sBAAsB;EACtB,mCAAmC;EACnC,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,MAAM;EACN,QAAQ;EACR,SAAS;AACX;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,WAAW;AACb;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;AACX;AACA;EACE,YAAY;AACd","sourcesContent":[".w-md-editor {\n  color: #24292e;\n  text-align: left;\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.1), 0 0 0 rgba(16, 22, 26, 0), 0 1px 1px rgba(16, 22, 26, 0.2);\n  border-radius: 3px;\n  position: relative;\n  background-color: #fff;\n  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\n}\n.w-md-editor-content {\n  position: relative;\n  border-radius: 0 0 3px 0;\n  height: calc(100% - 39.1px);\n}\n.w-md-editor-input {\n  width: 50%;\n  height: 100%;\n}\n.w-md-editor-preview {\n  width: 50%;\n  box-sizing: border-box;\n  box-shadow: inset 1px 0 0 0 #dfdfe0;\n  position: absolute;\n  padding: 10px 20px;\n  overflow: auto;\n  top: 0;\n  right: 0;\n  bottom: 0;\n}\n.w-md-editor-show-preview .w-md-editor-input {\n  width: 0%;\n  overflow: hidden;\n  background-color: #fdfdfd;\n}\n.w-md-editor-show-preview .w-md-editor-preview {\n  width: 100%;\n  box-shadow: inset 0 0 0 0;\n}\n.w-md-editor-show-edit .w-md-editor-input {\n  width: 100%;\n}\n.w-md-editor-show-edit .w-md-editor-preview {\n  width: 0%;\n  padding: 0;\n}\n.w-md-editor-fullscreen {\n  overflow: hidden;\n  position: fixed;\n  z-index: 9999;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n.w-md-editor-fullscreen .w-md-editor-content {\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
